import { createThemeContract } from '@vanilla-extract/css';
import { MEDIA_QUERIES } from './01-tokens/breakpoints.css';
import { themeColorVars } from './02-settings/';
import { components } from './04-components/';

/**
 * This is the declaration of the theme structure
 * used by both the applications and the libraries
 *
 * You can found the actual implementation of the theme here:
 *
 * - BACKOFFICE: libraries/bo-theme/src/lib/boTheme.css.ts
 * - HR:  libraries/hr-theme/src/lib/hrTheme.css.ts
 * **/
const themeContract = createThemeContract({
  font: {
    family: {
      content: null,
    },
    size: {
      h1: null,
      h2: null,
      h3: null,
      textSm: null,
      textMd: null,
      textLg: null,
      iconSm: null,
      iconMd: null,
      iconLg: null,
      iconXl: null,
      icon2xl: null,
      icon3xl: null,
    },
    weight: {
      regular: null,
      bold: null,
    },
  },
  space: {
    x1: null,
    x2: null,
    x3: null,
    x4: null,
    x5: null,
    x6: null,
    x7: null,
    x8: null,
    x9: null,
    x10: null,
    x11: null,
    x12: null,
    x13: null,
    x14: null,
    x15: null,
    x16: null,
    x17: null,
    x18: null,
    x19: null,
    x20: null,
  },
  breakpoints: MEDIA_QUERIES,
  transitions: {
    slow: null,
    default: null,
    fast: null,
  },
  durations: {
    slow: null,
    default: null,
    fast: null,
  },
  radius: {
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
    circle: null,
    pill: null,
  },
  shadow: {
    elevationLight: null,
    elevationSmall: null,
    elevationMedium: null,
    elevationLarge: null,
    elevationExtraLarge: null,
  },
  zIndex: {
    content: null,
    dropdown: null,
    modal_background: null,
    modal: null,
    sidePanel_background: null,
    sidePanel: null,
    popover: null,
    tooltip: null,
    toast: null,
  },
  colors: { ...themeColorVars, components },
});

// Export with type assertion to work around MapLeafNodes incompatibility with CSS properties
// This is necessary because vanilla-extract's createThemeContract returns MapLeafNodes type
// which is not compatible with CSS property types

export const themeVars = themeContract as unknown as typeof themeContract;
